import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

export const dialogSlotRecipe = defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  className: 'ac-dialog',
  base: {
    backdrop: {
      width: '100vw',
      height: '100dvh',
      position: 'fixed',
      backgroundColor: 'dark/80',
      top: 0,
      left: 0,
      // Same layer as the dialog itself, so it covers everything below the dialog, e.g. the project warnings handle.
      '--dialog-z-index': 'zIndex.modal',
      zIndex: 'calc(var(--dialog-z-index) + var(--layer-index, 0))',
      _open: {
        animationName: 'fade-in',
        animationDuration: 'slow',
      },
      _closed: {
        animationName: 'fade-out',
        animationDuration: 'moderate',
      },
    },
    positioner: {
      display: 'flex',
      width: '100vw',
      height: '100dvh',
      position: 'fixed',
      left: 0,
      top: 0,
      '--dialog-z-index': 'zIndex.modal',
      zIndex: 'calc(var(--dialog-z-index) + var(--layer-index, 0))',
      justifyContent: 'center',
      overscrollBehaviorY: 'none',
      alignItems: 'center',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%',
      outline: 0,
      '--dialog-z-index': 'zIndex.modal',
      zIndex: 'calc(var(--dialog-z-index) + var(--layer-index, 0))',

      maxW: '450px',
      minH: '300px',
      height: '300px',

      // borderRadius: 'double',
      // overflow: 'hidden',

      _open: {
        animationDuration: 'moderate',
        animationName: 'scale-in, fade-in',
      },
      _closed: {
        animationDuration: 'faster',
        animationName: 'scale-out, fade-out',
      },
    },
    header: {
      padding: '30px',
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '24px',
      color: 'dark',
      letterSpacing: '0.18px',
      backgroundColor: 'grey.light.0',
      borderTopRadius: 'double',
    },
    body: {
      padding: '30px',
      flexGrow: 1,
      backgroundColor: 'white',
      '&:last-child': {
        borderBottomRadius: 'double',
      },
    },
    footer: {
      padding: '30px',
      backgroundColor: 'white',
      '&:last-child': {
        borderBottomRadius: 'double',
      },
    },
    closeTrigger: {
      position: 'absolute',
      top: '-50px',
      right: '-50px',
      border: '1px solid white',
      width: '40px',
      height: '40px',
      maxWidth: '40px',
      maxHeight: '40px',
      borderRadius: '50%',
      flexGrow: 0,
      flexShrink: 0,
      background: 'transparent',
      cursor: 'pointer',
      padding: 0,
      minWidth: '40px',

      '& svg': {
        stroke: 'white',
        fill: 'white',
        width: '20px',
        height: '20px',
      },

      _hover: {
        borderColor: 'grey.light.1',
        '& svg': {
          stroke: 'grey.light.1',
          fill: 'grey.light.1',
        },
      },
      _active: {
        borderColor: 'grey.light.1',
        '& svg': {
          stroke: 'grey.light.1',
          fill: 'grey.light.1',
        },
      },
    },
  },
  variants: {
    nopad: {
      true: {
        content: {
          padding: 0,
        },
      },
    },
    positioning: {
      free: {
        content: {
          position: 'relative',
          maxW: '100vw',
          maxH: '100vh',
          height: '100vh',
          width: '100vw',
        },
      },
    },
    variant: {
      error: {
        header: {
          backgroundColor: 'white',
          color: 'halton.red',
          fontWeight: 400,
          paddingBottom: '0px',
        },
        content: {
          maxW: '500px',
          minH: '200px',
          height: 'auto',
          paddingTop: '0px',

          color: 'grey.light.3',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
        },
        body: {
          padding: '10px 30px',
        },
        footer: {
          paddingTop: '0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'stretch',
          alignItems: 'center',
          gap: '20px',
          '& > button': {
            flexGrow: 1,
          },
        },
      },
      'equation-warning': {
        header: {
          color: 'color-mix(in srgb, {colors.halton.yellow} 60%, {colors.halton.red} 100%)',
          padding: '30px 30px 15px',
          borderBottom: '1px solid {colors.grey.light.1}',
        },
        content: {
          maxW: '500px',
          minH: '200px',
          height: 'auto',
          paddingTop: '0px',

          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
        },
        body: {
          padding: '10px 30px',
        },
        footer: {
          paddingTop: '0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'stretch',
          alignItems: 'center',
          gap: '20px',
          '& > button': {
            flexGrow: 1,
          },
        },
      },
    },
  },
});
